import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import {WistiaVideoEmbed} from './'

const MapVideoOverlay = observer(() => {
    const {uiStore: {home__map__showVideo, hideMapVideo}} = useStore();
    if (!home__map__showVideo) return null;

    return (
        <div className='video-overlay'>
            <div className="close-overlay" onClick={hideMapVideo}></div>
            <WistiaVideoEmbed id="l370ii4xar"/>
            <CloseButton/>
            <style jsx>{`
                .video-overlay {
                    position: fixed;
                    top: var(--nav--height);
                    width: 100%;
                    bottom: 0;
                    left: 0;
                    z-index: 10;
                    background: rgba(0,0,0,.85);
                }

                .close-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 1;
                }

                video {
                    position: absolute; 
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 65%;
                    z-index: 2;
                }
                video::-webkit-media-controls-fullscreen-button { display: none; }
            `}</style>
        </div>
    )
});

const CloseButton = () => {
    const {uiStore: {hideMapVideo}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore()
    return (
        <svg 
            onMouseEnter={() => handleMouseEnter("action", "Keep Exploring")}
            onMouseLeave={handleMouseLeave}
            onClick={() => {
                hideMapVideo()
                handleMouseLeave()
            }} pwidth="58px" height="58px" viewBox="0 0 58 58">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Being-Copy-69" transform="translate(-1755.000000, -105.000000)">
                    <g id="Group-8" transform="translate(1755.000000, 105.000000)">
                        <g id="Group-3" fill="#FFFFFF">
                            <circle id="Oval" cx="29" cy="29" r="29"></circle>
                        </g>
                        <line x1="18.9875294" y1="18" x2="41.0543863" y2="40.0668568" id="Path-3" stroke="#000000" strokeWidth="3" strokeLinecap="round"></line>
                        <line x1="18.9875294" y1="18" x2="41.0543863" y2="40.0668568" id="Path-3" stroke="#000000" strokeWidth="3" strokeLinecap="round" transform="translate(30.020958, 29.033428) scale(1, -1) translate(-30.020958, -29.033428) "></line>
                    </g>
                </g>
            </g>
            <style jsx>{`
                svg {
                    position: fixed; 
                    top: 70px;
                    right: 30px;
                    cursor: pointer;
                    width: 40px;
                    z-index: 2;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    svg {
                        display: none;
                    }
                }
            `}</style>
        </svg>

    )
}




export default MapVideoOverlay